import { ProcesarDatosApi } from "../api/ApiFetch";
const controladorTecnologia = "estados";

export const ObtenerEstadosCompleto = async () => {
    const url = `${controladorTecnologia}/ObtenerEstadosCompleto`;
    return await ProcesarDatosApi('GET', url);
}

export const ObtenerEstadosVacantesCompleto = async () => {
    const url = `${controladorTecnologia}/ObtenerEstadosVacantesCompleto`;
    return await ProcesarDatosApi('GET', url);
}
